import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TargetGroupOptionResource } from "../../types/targetGroup";
import { TargetGroupMultiSelectField } from "../../ui/TargetGroupMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemTargetGroup: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<TargetGroupOptionResource[]>(name);
	const { targetGroups, targetGroupsIsLoading, renderTargetGroupsAsCheckboxes } = useEventFilterAccordionItems();

	if (!targetGroups || !targetGroups.length) {
		return null;
	}

	const renderBody = () => {
		if (targetGroupsIsLoading) return <Loading />;
		if (renderTargetGroupsAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{targetGroups.map((targetGroup) => (
						<FilterCheckbox
							key={`${targetGroup.id}`}
							name={`targetGroup-${targetGroup.id}`}
							value={value.some((v) => v.id === targetGroup.id)}
							label={targetGroup.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, targetGroup] : value.filter((v) => v.id !== targetGroup.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <TargetGroupMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Target group")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
